import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Grid, Button, Typography } from '@material-ui/core'
import { useCookies } from 'react-cookie'
import { useAuth } from '../../auth/Auth'
import Loader from '../loader/Loader'
import LoginImage from '../../assets/img/ConsumerLoginImage.png'
import '../login/Login.css'

const GuestChargingEntry = () => {
    const { pathId } = useParams()
    const history = useHistory()
    const auth = useAuth()
    const [, setCookie] = useCookies(['inviteUuid'])
    const [isChecking, setIsChecking] = useState(true)
    const [isSigningOut, setIsSigningOut] = useState(false)
    const [showReauthPrompt, setShowReauthPrompt] = useState(false)

    useEffect(() => {
        if (pathId) {
            setCookie('inviteUuid', pathId, { path: '/' })
        }

        auth.isUserLoggedIn()
            .then((user) => {
                const roles = JSON.parse(
                    user?.signInUserSession?.idToken?.payload?.roles || '[]'
                )
                const isGuest =
                    Array.isArray(roles) && roles.includes('CONSUMER_GUEST')

                if (isGuest) {
                    setIsChecking(false)
                    setShowReauthPrompt(true)
                } else {
                    // Logged in as a non-guest role — just go to dashboard
                    history.replace('/dashboard')
                }
            })
            .catch(() => {
                // Not authenticated — send to login with inviteUuid in state so
                // Login.js can pass it in validationData without relying on cookie timing.
                history.replace('/sign-in', { inviteUuid: pathId })
            })
    }, [pathId])

    const handleContinueToSignIn = () => {
        setShowReauthPrompt(false)
        setIsSigningOut(true)
        auth.signout().then(() => {
            history.replace('/sign-in', { inviteUuid: pathId })
        })
    }

    if (isChecking || isSigningOut) {
        return <Loader />
    }

    if (showReauthPrompt) {
        return (
            <div className="login-page-container">
                <Grid container direction="row" alignItems="stretch">
                    <Grid
                        item
                        xs={12}
                        md={6}
                        lg={5}
                        className="login-page-container-left"
                    >
                        <div className="medium-header">Activate Guest Access</div>
                        <hr />
                        <Typography
                            variant="h5"
                            style={{ marginTop: '8px', marginBottom: '24px', lineHeight: 1.6 }}
                        >
                            You've received a new guest charging link. To activate
                            your updated access, please re-enter your password on
                            the next screen.
                        </Typography>
                        <Button
                            className="sign-up-button"
                            variant="contained"
                            onClick={handleContinueToSignIn}
                        >
                            Continue to Sign In
                        </Button>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        md={6}
                        lg={7}
                        className="login-page-container-right"
                    >
                        <div className="large-header">
                            Renew Your
                            <br />
                            Guest Charging Access
                        </div>
                        <div className="login-image-container">
                            <img
                                alt="guest charging"
                                className="login-image"
                                src={LoginImage}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }

    return <Loader />
}

export default GuestChargingEntry
